// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21 2H3V6H2V8H22V6H21V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 10H3V20H2V22H10.5V20H9.5V15.5C9.5 14.1193 10.6193 13 12 13C13.3807 13 14.5 14.1193 14.5 15.5V20H13.5V22H22V20H21V10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-dam-6-filled')
export default class Dam6FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-6-filled',
    }
  }
}
